import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import moment from "moment";
import Swal from "sweetalert2";
import $ from "jquery";
import { toast, ToastContainer } from "react-toastify";
import { LinearProgress } from "@mui/material";
import OrgContext from "../../organisation/OrgContext";
import { useNavigate } from "react-router-dom";
import { frFR, enUS } from "@mui/x-data-grid";
import { baseURL } from "../../services/api";
import Papa from "papaparse";
import logo from "../../assets/images/ElmanagerLogo.png";
import useAuthHelper from "../../helpers/AuthHelper";
import { formatNumber, isNumeric } from "../../helpers/formater";

export function BonCommandes() {
  const [t, i18n] = useTranslation();
  const { organisation } = useContext(OrgContext);
  const [bonCommandes, setBonCommandes] = useState([]);
  const [selectedCommande, setSelectedCommande] = useState(null);
  const [filteredBonCommandes, setFilteredBonCommandes] = useState([]);
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [grandTotal, setGrandTotal] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [factureNumber, setFactureNumber] = useState("");
  const [factureDate, setFactureDate] = useState("");
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [nbInvoices, setNbInvoices] = useState(0);
  const [invoicesNums, setInvoicesNums] = useState([]);
  const [numExist, setExitNum] = useState(false);

  const navigate = useNavigate();
  const { onlyCommercial, hadEditAccess, hadDeleteAccess } = useAuthHelper();
  useEffect(() => {
    onlyCommercial();
    hadEditAccess();
    hadDeleteAccess();
  }, [onlyCommercial, hadEditAccess, hadDeleteAccess]);
  useEffect(() => {
    if (organisation.id) {
      fetchBonCommandes();
    }
  }, [organisation.id]);

  const fetchBonCommandes = async () => {
    setLoadingData(true);
    try {
      const response = await jwtInterceoptor.get(
        `${baseURL}/data/bon-commandes/${organisation.id}`,
      );
      if (response.status === 200) {
        setBonCommandes(response.data);
      }
    } catch (error) {
      console.error(error);
    }
    setLoadingData(false);
  };

  useEffect(() => {
    if (organisation?.id) {
      getNbsInvoices();
    }
  }, [organisation?.id]);

  const getNbsInvoices = async () => {
    let resp = await jwtInterceoptor.get(
      `/data/nb-factures/factures-achat/${organisation?.id}`,
    );
    if (resp.status == 200) {
      let data = resp.data;
      if (data?.status) {
        setNbInvoices(data?.nb_factures);
        setInvoicesNums(data.data);
      }
    }
  };

  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
       setFactureNumber(`FACT-ACHAT-${nbInvoices + 1}`);
        setExitNum(false);
    } else {
      setFactureNumber("");
    }
  };

  const handleFilterDate = () => {
    let startDate = moment(dateDebut, "YYYY-MM-DD").startOf("day");
    let endDate = dateFin
      ? moment(dateFin, "YYYY-MM-DD").endOf("day")
      : moment().endOf("day");

    if (startDate.isAfter(endDate)) {
      toast.warning(
        t("La date de début ne peut pas être supérieure à la date de fin."),
        { position: "top-right", autoClose: 5000 },
      );
      return;
    }

    if (dateDebut && (dateFin || endDate)) {
      const filteredData = bonCommandes.filter((bonCommande) => {
        const bonCommandeDate = moment(
          bonCommande.created_at,
          "YYYY-MM-DD",
        ).startOf("day");
        return bonCommandeDate.isBetween(startDate, endDate, null, "[]");
      });

      if (filteredData.length === 0) {
        toast.warning(t("Aucun bon de commande trouvé entre ces dates."), {
          position: "top-right",
          autoClose: 5000,
        });
      }

      setFilteredBonCommandes(filteredData);
    } else {
      toast.error(t("Veuillez sélectionner les dates de début et de fin."), {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };
  const saveFA = async (
    bonCommande,
    factureNumber,
    factureDate,
    autoIncrementInvoiceNumber,
  ) => {
    Swal.fire({
      title: t("Êtes-vous sûr ?"),
      text: t(
        "Voulez-vous générer une facture d'achat pour ce bon de commande ?",
      ),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Oui, générer !"),
      cancelButtonText: t("Annuler"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoadingData(true); // Activer le chargement
        try {
          // Convertir la date au format attendu par la base de données
          const formattedDueDate = moment(bonCommande.due_date).format(
            "YYYY-MM-DD",
          );

          let is_custom_invoice_number = 0;
          let numeroDeFacture = "";

          if (autoIncrementInvoiceNumber === false) {
            is_custom_invoice_number = 1;
            numeroDeFacture = isNumeric(factureNumber)
              ? `FACT-ACHAT-${formatNumber(factureNumber)}`
              : `FACT-ACHAT-${factureNumber}`;
          } else {
            numeroDeFacture = `FACT-ACHAT-${nbInvoices + 1}`;
          }

          // Convertir les produits en JSON
          const productsJSON = JSON.stringify(
            bonCommande.bon_commande_products,
          );

          const response = await jwtInterceoptor.post(
            `${baseURL}/data/user/factures_achat/add`,
            {
              bon_commande_id: bonCommande.id,
              organisation_id: organisation.id,
              supplier_id: bonCommande.fournisseur_id,
              total: bonCommande.total_ht,
              total_ttc: bonCommande.total_ttc,
              total_tva: bonCommande.total_tva,
              type: "achat",
              products: productsJSON, // Envoyer les produits sous forme de chaîne JSON
              status: 1, // Toujours égal à 1
              payed_amount: 0, // Montant payé initialisé à 0
              payment_method: 0, // Exemple de méthode de paiement par défaut
              due_date: formattedDueDate, // Utiliser la date formatée
              is_custom_invoice_number: false,
              due_date: factureDate, // ← date saisie dans l'offcanvas
              invoice_number: numeroDeFacture,
            },
          );
          if (response.status === 200) {
            Swal.fire(
              t("Succès !"),
              t("La facture d'achat a été générée avec succès."),
              "success",
            );

            // Supprimer le bon de commande après succès
            await deleteBonCommande(bonCommande);
          }
        } catch (error) {
          console.error(error);
          Swal.fire(
            t("Erreur !"),
            t("Une erreur s'est produite lors de la génération de la facture."),
            "error",
          );
        } finally {
          setLoadingData(false); // Désactiver le chargement
        }
      }
    });
  };

  const deleteBonCommande = async (bonCommande) => {
    Swal.fire({
      title: t("Êtes-vous sûr ?"),
      text: t("Cette action est irréversible !"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Oui, supprimer !"),
      cancelButtonText: t("Annuler"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await jwtInterceoptor.delete(
            `${baseURL}/data/bon-commande/${bonCommande.id}`,
          );
          if (response.status === 200) {
            setBonCommandes((prev) =>
              prev.filter((item) => item.id !== bonCommande.id),
            );
            Swal.fire(
              t("Supprimé !"),
              t("Le bon de commande a été supprimé."),
              "success",
            );
          }
        } catch (error) {
          console.error(error);
          Swal.fire(t("Erreur !"), t("Une erreur s'est produite."), "error");
        }
      }
    });
  };

  const columns = [
    {
      field: "Numéro BC",
      headerName: t("Numéro BC"),
      valueGetter: (params) => `${params.row.title}`,
      width: 200,
    },
    {
      field: "Fournisseur",
      headerName: t("Fournisseur"),
      valueGetter: (params) => params.row.fournisseur.companyName,
      flex: 1,
    },
    {
      field: "Date de commande",
      headerName: t("Date de commande"),
      valueGetter: (params) =>
        `${moment(params.row.created_at).format("DD/MM/YYYY") || ""}`,
      flex: 1,
    },
    {
      field: "Total TTC",
      headerName: t("Total TTC"),
      valueGetter: (params) =>
        `${Number(params.row.total_ttc).toFixed(2)} ${
          organisation?.currency?.code || ""
        }`,
      flex: 1,
    },
    {
      field: "action",
      headerName: t("Actions"),
      width: 250,
      renderCell: (params) => {
        const onDelete = () => {
          if (!hadDeleteAccess()) {
            toast.error(
              t(
                "Vous n'avez pas les droits pour supprimer ce bon de commande.",
              ),
              {
                position: "top-right",
                autoClose: 5000,
              },
            );
            return;
          }
          deleteBonCommande(params.row);
        };
        const onEdit = () => {
          if (!hadEditAccess()) {
            toast.error(
              t("Vous n'avez pas les droits pour modifier ce bon de commande."),
              {
                position: "top-right",
                autoClose: 5000,
              },
            );
            return;
          }
          navigate(`/boncommande/edit/${params.row.id}`);
        };
        const onDetails = () =>
          navigate(`/boncommande/details/${params.row.id}`);
        const onCreateFA = (e) => {
          const inv = params.row;
          console.log("invoice object =>", inv);
          setSelectedCommande(inv);
          setFactureNumber("");
          setAutoIncrementInvoiceNumber(false);
          setExitNum(false);
          setFactureDate(new Date().toISOString().split("T")[0]);
        };
        return (
          <div className="btn-list">
            <button
              onClick={onEdit}
              className="btn btn-sm btn-primary"
              title={t("Modifier")}
            >
              <span className="fe fe-edit"></span>
            </button>
            <button
              onClick={onDetails}
              className="btn btn-sm btn-secondary"
              title={t("Voir le détails")}
            >
              <span className="fe fe-eye"></span>
            </button>
            <button
              onClick={onDelete}
              className="btn btn-sm btn-danger"
              title={t("Supprimer")}
            >
              <span className="fe fe-trash-2"></span>
            </button>
            <button
              data-bs-toggle="offcanvas"
              href="#offcanvasTransferFacture"
              role="button"
              aria-controls="offcanvasTransferFacture"
              onClick={onCreateFA}
              className="btn btn-sm btn-warning"
              title={t("Générer une facture d'achat")}
            >
              <span className="fe fe-file"></span>
            </button>
          </div>
        );
      },
    },
  ];
  const downloadEtatFac = async () => {
    if (!selectedRow || selectedRow.length === 0) {
      console.warn("Aucune facture sélectionnée");
      return;
    }

    // Nouvelle structure qui affiche les produits sur des lignes distinctes
    const donneesFormatees = [];
    let totalQte = 0;
    let totalPrixHT = 0;
    let totalPaiement = 0;

    // Parcourir chaque facture
    selectedRow.forEach((facture) => {
      if (
        facture.bon_commande_products &&
        facture.bon_commande_products.length > 0
      ) {
        // Pour chaque produit de la facture
        facture.bon_commande_products.forEach((item, index) => {
          // Calculer les totaux
          const qte = Number(item.qty || 0);
          const prixUnitHT = Number(item.price_unit_ht || 0);
          const prixHT = Number(item.total_ht || 0);

          totalQte += qte;
          totalPrixHT += prixHT;

          // Ajouter une ligne pour ce produit
          donneesFormatees.push({
            date_facture: facture.created_at?.split("T")[0] || "N/A",
            date_echeance: facture.due_date?.split("T")[0] || "N/A",
            num_facture: facture.title || "N/A",
            num_pieces: facture.id || "N/A",
            compte_client: facture.fournisseur?.account || "N/A",
            nom_client: facture.fournisseur?.name || "N/A",
            ice_client: facture.fournisseur?.ice || "N/A",
            nom_article: item.product?.name || item.details || "N/A",
            val_pu_ht: prixUnitHT,
            val_qte: qte,
            val_pt_ht: prixHT,
            // date_paiement: facture.payment && facture.payment.length > 0 ?
            //                facture.payment[facture.payment.length-1].created_at?.split("T")[0] || "N/A" : "N/A",
            // val_paiement:  montantPaye , // Afficher le paiement uniquement sur la première ligne
            // mode_paiement:  getMoyenPaiement(facture) // Afficher le mode de paiement uniquement sur la première ligne
          });
        });
      }
    });

    // Ajouter une ligne de total avec la nouvelle structure
    donneesFormatees.push({
      date_facture: "",
      date_echeance: "",
      num_facture: "",
      num_pieces: "",
      compte_client: "",
      nom_client: "",
      ice_client: "",
      nom_article: "TOTAL",
      val_pu_ht: "",
      val_qte: totalQte.toFixed(2),
      val_pt_ht: totalPrixHT.toFixed(2),
      // date_paiement: "",
      // val_paiement: totalPaiement.toFixed(2),
      // mode_paiement: ""
    });

    const { value: fileType } = await Swal.fire({
      title: "Choisissez le format de téléchargement",
      input: "radio",
      inputOptions: {
        csv: "CSV",
        pdf: "PDF",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Vous devez choisir une option!";
        }
      },
      showCancelButton: true,
      confirmButtonText: "Télécharger",
      cancelButtonText: "Annuler",
    });

    if (fileType === "csv") {
      const csv = Papa.unparse(donneesFormatees, { delimiter: ";" });
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "etat_factures.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (fileType === "pdf") {
      const { jsPDF } = await import("jspdf");
      const autoTable = (await import("jspdf-autotable")).default;

      const doc = new jsPDF({ orientation: "landscape" });
      const headerHeight = 30;
      const logoWidth = 30;
      const logoHeight = 15;
      const organisationName = organisation?.name || "Nom de l'organisation";
      const tirageDate = `Date de tirage : ${moment().format(
        "DD/MM/YYYY à HH:mm",
      )}`;
      doc.setFontSize(10);
      doc.text(organisationName, 10, 15);
      try {
        const logoX = (doc.internal.pageSize.width - logoWidth) / 2; // Centrer horizontalement
        doc.addImage(logo, "PNG", logoX, 5, logoWidth, logoHeight); // Position : centré, 5 (y)
      } catch (error) {
        console.error("Erreur lors de l'ajout du logo :", error);
      }

      // Ajouter le titre sous le logo
      doc.setFontSize(12);
      doc.text("État de Facturations", doc.internal.pageSize.width / 2, 25, {
        align: "center",
      }); // Centré horizontalement

      // Ajouter la date de tirage à droite
      doc.setFontSize(10);
      const tirageX = doc.internal.pageSize.width - 10; // Aligné à droite
      doc.text(tirageDate, tirageX, 15, { align: "right" });

      // Ajouter une ligne pour séparer l'en-tête
      doc.line(
        10,
        headerHeight,
        doc.internal.pageSize.width - 10,
        headerHeight,
      );

      // Définir les colonnes avec les mêmes noms que dans le CSV
      const columns = [
        "Date Facture",
        "Date Échéance",
        "Numéro Facture",
        "N° Pièce",
        "Compte Client",
        "Nom Client",
        "ICE Client",
        "Nom Article",
        "PU HT",
        "Qté",
        "PT HT",
        // "Date Paiement",
        // "Montant Payé",
        // "Mode Paiement"
      ];

      // Transformer les données pour le PDF en utilisant les mêmes champs que le CSV
      const rows = donneesFormatees.map((facture) => [
        facture.date_facture,
        facture.date_echeance,
        facture.num_facture,
        facture.num_pieces,
        facture.compte_client,
        facture.nom_client,
        facture.ice_client,
        facture.nom_article,
        typeof facture.val_pu_ht === "number"
          ? facture.val_pu_ht.toFixed(2)
          : facture.val_pu_ht,
        facture.val_qte,
        typeof facture.val_pt_ht === "number"
          ? facture.val_pt_ht.toFixed(2)
          : facture.val_pt_ht,
        facture.date_paiement,
        typeof facture.val_paiement === "number"
          ? facture.val_paiement.toFixed(2)
          : facture.val_paiement,
        facture.mode_paiement,
      ]);

      // Appliquer des styles spécifiques pour la ligne de total
      const rowStyles = rows.map((_, index) =>
        index === rows.length - 1
          ? { fontStyle: "bold", fillColor: [240, 240, 240] }
          : {},
      );

      // Générer le tableau avec l'en-tête
      autoTable(doc, {
        head: [columns],
        body: rows,
        startY: headerHeight + 10,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [61, 49, 155] }, // Couleur de l'en-tête
        rowStyles: rowStyles, // Appliquer les styles pour chaque ligne
      });

      // Télécharger le PDF
      doc.save("etat_factures.pdf");
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="row" style={{ zIndex: 1}}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header container-fluid row">
              <div className="col-md-9 col-sm-12 card-title">
                <h3>{t("Liste des bons de commande")}</h3>
              </div>
              <div className="col-md-3 card-title">
                <button
                  className="btn btn-primary"
                  onClick={() => navigate("/boncommande/add")}
                >
                  {t("Ajouter un bon de commande")}
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="mb-4 d-flex">
                <div className="col-3 mx-4">
                  <label htmlFor="dateDebut">{t("Date de début")}:</label>
                  <input
                    type="date"
                    className="form-control"
                    id="dateDebut"
                    value={dateDebut}
                    onChange={(e) => setDateDebut(e.target.value)}
                  />
                </div>
                <div className="col-3 mx-4">
                  <label htmlFor="dateFin">{t("Date de fin")}:</label>
                  <input
                    type="date"
                    className="form-control"
                    id="dateFin"
                    value={dateFin}
                    onChange={(e) => setDateFin(e.target.value)}
                  />
                </div>
                <div className="col-4">
                  <button
                    className="btn btn-primary mx-4 mt-4"
                    onClick={handleFilterDate}
                  >
                    {t("Filtrer par date")}
                  </button>
                  {filteredBonCommandes.length > 0 && (
                    <button
                      className="btn btn-danger mt-4"
                      onClick={() => setFilteredBonCommandes([])}
                    >
                      {t("Afficher tout")}
                    </button>
                  )}
                </div>
              </div>
              <div style={{ height: 600, width: "100%" }}>
                <DataGrid
                  rows={
                    filteredBonCommandes.length
                      ? filteredBonCommandes
                      : bonCommandes
                  }
                  columns={columns}
                  checkboxSelection
                  onRowSelectionModelChange={(ids) => {
                    const selectedIDs = new Set(ids);
                    const selectedBonCommandes = bonCommandes.filter((row) =>
                      selectedIDs.has(row.id),
                    );
                    const total = selectedBonCommandes.reduce(
                      (acc, bonCommande) => acc + bonCommande.total_ttc,
                      0,
                    );
                    setGrandTotal(total);
                    setSelectedRow(selectedBonCommandes);
                    console.log("selectedBonCommandes", selectedBonCommandes);
                  }}
                  loading={loadingData}
                  localeText={
                    i18n.language === "fr"
                      ? frFR.components.MuiDataGrid.defaultProps.localeText
                      : enUS.components.MuiDataGrid.defaultProps.localeText
                  }
                  slots={{
                    loadingOverlay: LinearProgress,
                    toolbar: GridToolbar,
                  }}
                />
              </div>
              {grandTotal && (
                <div className="card-footer">
                  <div className="row">
                    <div className="col">
                      <button
                        className="btn btn-primary"
                        onClick={() => downloadEtatFac()}
                      >
                        Telecharger etat de facturation
                      </button>
                    </div>
                    <div className="col">
                      {grandTotal ? (
                        <div className="d-flex flex-row-reverse">
                          <span
                            className="text-success"
                            style={{
                              fontSize: 19,
                              fontWeight: "bold",
                            }}
                          >
                            {t("Total général")} {Number(grandTotal).toFixed(2)}{" "}
                            {organisation?.currency?.code} TTC
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end cutomWith"
        tabIndex="-1"
        id="offcanvasTransferFacture"
        aria-labelledby="offcanvasTransferFactureLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasTransferFactureLabel">
            {t("Transférer en facture")}
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="fe fe-x fs-18"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="form-group">
            <label>
              {" "}
              N° de la facture * (
              {t("ce numéro servira de référence pour votre facture originale")}
              )
            </label>
            <input
              type="text"
              className="form-control"
              value={factureNumber}
              disabled={autoIncrementInvoiceNumber}
              onChange={(e) => {
                setFactureNumber(e.target.value);
                let idx = invoicesNums.findIndex(
                  (c) =>
                    e.target.value == c?.invoice_number ||
                    e.target.value ==
                      (c.is_custom_invoice_number == 1
                        ? c.invoice_number
                        : `Fact-achat-${formatNumber(c?.invoice_number)}`),
                );
                setExitNum(idx !== -1);
              }}
              id="factureNumberInput"
            />
            {!autoIncrementInvoiceNumber && numExist ? (
              <span className="text-danger">
                {t("Ce numéro de facture existe déjà")}
              </span>
            ) : null}
            <label className="custom-control custom-checkbox-md mt-2">
              <input
                type="checkbox"
                className="custom-control-input"
                checked={autoIncrementInvoiceNumber}
                onClick={() =>
                  setAutoIncrementInvoiceNumber(!autoIncrementInvoiceNumber)
                }
                onChange={(e) => {
                  handleAutoIncrementInvoiceNumber();
                }}
              />
              <span className="custom-control-label">
                {t("Utiliser le numéro de facture auto-incrementer")}
              </span>
            </label>
          </div>
          <div className="form-group mt-3">
            <label>{t("Date de facture")}*</label>
            <input
              type="date"
              className="form-control"
              value={factureDate}
              onChange={(e) => setFactureDate(e.target.value)}
            />
          </div>
          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="offcanvas"
            >
              {t("Annuler")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() =>
                saveFA(
                  selectedCommande,
                  factureNumber,
                  factureDate,
                  autoIncrementInvoiceNumber,
                )
              }
              disabled={
                !factureDate ||
                (!autoIncrementInvoiceNumber && (!factureNumber || numExist))
              }
              data-bs-dismiss="offcanvas"
            >
              {t("Confirmer la création")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
